import { render } from "./FeederList.vue?vue&type=template&id=68235caa&scoped=true"
import script from "./FeederList.vue?vue&type=script&lang=js"
export * from "./FeederList.vue?vue&type=script&lang=js"

import "./FeederList.vue?vue&type=style&index=0&id=68235caa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68235caa"

export default script